import React from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationKey } from '../../i18n/translationKeys';

// Visual only: each row is a toggle button whose cells read in column order, so the labels are hidden
// from assistive tech rather than announced as headers for cells they cannot be tied to.
export const HistoryTableHeader: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div aria-hidden="true" className="col-span-full grid grid-cols-subgrid items-center h-9 px-m md:px-l bg-surface-secondary text-s font-semibold text-content-subtle" data-testid="history-table-header">
            <span>{t(TranslationKey.History.Columns.Date)}</span>
            <span className="md:hidden">{t(TranslationKey.History.Columns.Description)}</span>
            <span className="hidden md:block">{t(TranslationKey.History.Columns.Type)}</span>
            <span className="hidden md:block">{t(TranslationKey.History.Columns.Detail)}</span>
            <span className="text-right">{t(TranslationKey.History.Columns.Total)}</span>
            <span />
        </div>
    );
};
